export default "__VITE_ASSET__Cf4_Ubl2__"